import type { CancelSource } from '@/constants/CANCEL_SOURCES'

export type CancellableConfig = {
  signal: AbortSignal
  metadata: { cancelSource: CancelSource }
}

export type Cancellable = {
  readonly signal: AbortSignal
  readonly config: CancellableConfig
  abort: (reason?: string) => void
}

export const createCancellable = (source: CancelSource): Cancellable => {
  const controller = new AbortController()
  return {
    get signal() {
      return controller.signal
    },
    get config(): CancellableConfig {
      return {
        signal: controller.signal,
        metadata: { cancelSource: source },
      }
    },
    abort(reason: string = 'superseded') {
      controller.abort(reason)
    },
  }
}
